import cookies from 'react-cookies';

const ABNtest = 'ABNtest';

/**
 * Отправка события в GA
 * @example
 * dataLayerPush({event: 'UAevent', category: 'sale', action: 'get gift'});
 * @param {JSON} params параметры события
 *
 * @deprecated
 */
 export function dataLayerPush(params) {
    window.dataLayer = window.dataLayer || [];
    const label = params.label || '';
    params[ABNtest] = cookies.load('abn_variant');

    const dataLayerParams = { ...params, label };

    window.dataLayer.push(dataLayerParams);
}
